import React from "react"
import PropTypes from "prop-types"
import { Typography } from "@mui/material"
import i18n from "i18n"

import { formatChartNumber } from "./utils/numberFormat"
import OverviewCard, {
  overviewCardValueSx,
  overviewCardHelperTextSx,
} from "./OverviewCard"

const PlannedSaleCard = ({ saleAmount, isLoading, currency }) => (
  <OverviewCard
    iconPreset="plannedSale"
    title={i18n.t("overview.plannedSaleCardTitle")}
    infoText={i18n.t("overview.plannedSaleCardTooltip")}
    loading={isLoading}
    sx={{ height: "100%" }}
  >
    <Typography sx={overviewCardValueSx}>
      {formatChartNumber(saleAmount, 2)} {currency}
    </Typography>
    <Typography variant="body2" sx={overviewCardHelperTextSx}>
      {i18n.t("overview.plannedSaleCardHelper")}
    </Typography>
  </OverviewCard>
)

PlannedSaleCard.propTypes = {
  saleAmount: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
  currency: PropTypes.string,
}

PlannedSaleCard.defaultProps = {
  isLoading: false,
  currency: "",
}

export default PlannedSaleCard
